import React from 'react';
import { Breakpoint, Stack, Text } from '@moda/om';
import { OrderDetailsShippingStatus } from '../../OrderDetailsMain/OrderDetailsItemsSections/OrderDetailsShippingStatus';
import { OrderItem } from '../../../hooks/useOrder';
import { useIsFineJewelryReturnPolicyCovered } from '../../../hooks/useIsFineJewelryReturnPolicyCovered';
import { OrderItemDetailsReturnPolicyMessage } from './OrderItemDetailsReturnPolicyMessage';

interface Props {
  item: OrderItem;
  showExtraDetails: boolean;
}

export const OrderItemDetails: React.FC<Props> = ({
  item: {
    attributes: {
      category,
      color,
      customization,
      designerName,
      details: { name },
      excessShipping,
      excludedFromRewards,
      isReturnable,
      isReturnableMessage,
      promotionApplicableMessage,
      quantity,
      returnPolicy,
      shippedOn,
      shippingStatus,
      size,
      status
    }
  },
  showExtraDetails
}) => {
  const isFineJewelryReturnPolicyCovered = useIsFineJewelryReturnPolicyCovered({
    attributes: { category, returnPolicy, shippedOn }
  } as OrderItem);

  return (
    <Stack space={3}>
      <Stack space={0}>
        <Text treatment="bold1">{designerName}</Text>
        <Text>{name}</Text>
      </Stack>

      <Breakpoint gt="sm">
        <Stack space={3} direction="horizontal">
          <Stack space={1} direction="horizontal">
            <Text color="cement">Color:</Text>
            <Text>{color}</Text>
          </Stack>

          <Stack space={1} direction="horizontal">
            <Text color="cement">Size:&nbsp;</Text>
            <Text>{size}</Text>
          </Stack>

          <Stack space={1} direction="horizontal">
            <Text color="cement">Quantity:&nbsp;</Text>
            <Text>{quantity}</Text>
          </Stack>
        </Stack>
      </Breakpoint>

      <Breakpoint lt="sm">
        <Stack space={1}>
          <Stack space={1} direction="horizontal">
            <Text color="cement">Color:</Text>
            <Text>{color}</Text>
          </Stack>
          <Stack space={1} direction="horizontal">
            <Text color="cement">Size:&nbsp;</Text>
            <Text>{size}</Text>
          </Stack>
          <Stack space={1} direction="horizontal">
            <Text color="cement">Quantity:&nbsp;</Text>
            <Text>{quantity}</Text>
          </Stack>
        </Stack>
      </Breakpoint>

      {showExtraDetails && (
        <>
          {excessShipping && <Text>{excessShipping}</Text>}

          <OrderItemDetailsReturnPolicyMessage
            isFineJewelry={category === 'FINE_JEWELRY'}
            isFineJewelryReturnPolicyCovered={isFineJewelryReturnPolicyCovered}
            isReturnable={isReturnable}
            message={isReturnableMessage}
            status={status}
          />

          <OrderDetailsShippingStatus shippingStatus={shippingStatus} />

          {promotionApplicableMessage && <Text>{promotionApplicableMessage}</Text>}

          {excludedFromRewards && <Text>{excludedFromRewards}</Text>}

          {customization && <Text>{customization}</Text>}
        </>
      )}
    </Stack>
  );
};
